const apiUrl =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:5000'
    : 'https://structured-metrics.herokuapp.com'

export default { apiUrl }
